/*
 * Smooth scroll
 */

class RLM_SmoothScroll {
    constructor (wrapper) {
        this.mainWrapper = $(wrapper);       
        this.initEvents();
    }

    initEvents () {
        this.mainWrapper.find('a[href*="#"]').not('[href="#"]').click(function(event) {
            if (
                location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
                location.hostname == this.hostname
            ) {
                let target = jQuery(this.hash);
                target = target.length ? target : jQuery('[name=' + this.hash.slice(1) + ']');

                if (target.length) {
                    event.preventDefault();
                    
                    jQuery('html, body').animate({
                        scrollTop: (target.offset().top - 64)
                    }, 1000);
                }
            }
        });
    }
}

new RLM_SmoothScroll(document.body);